/* lib/safeNext.js — валидация локального `?next=`-редиректа (anti open-redirect, S5-семья).
   Возвращает БЕЗОПАСНЫЙ локальный путь (строка, начинающаяся с одного `/`) или null.
   Используется в SignIn/SignUp, чтобы после входа вернуть анонима на лендинг курса
   (/course/<slug>), не дав увести его на внешний/`javascript:` адрес.

   Принимаем ТОЛЬКО относительные пути в пределах своего origin:
   - строка начинается ровно с одного `/` (не `//…` — protocol-relative);
   - не `/\…` (backslash-трюк, который браузер трактует как `//`);
   - до первого `/`-сегмента нет схемы (никаких `:` → отсекаем `javascript:`, `http:` и т.п.);
   - один безопасный decode (битый %-escape → null).
   Всё прочее (внешние URL, пустая строка, не-строка) → null. */

function safeNext(raw) {
  if (typeof raw !== 'string') return null;

  let value = raw.trim();
  if (!value) return null;

  // Один безопасный decode: «%2F%2Fevil» и подобное должно проверяться в раскрытом виде.
  // Битый escape (одиночный `%`) → URIError → отвергаем.
  let decoded;
  try {
    decoded = decodeURIComponent(value);
  } catch (e) {
    return null;
  }
  decoded = decoded.trim();
  if (!decoded) return null;

  // Управляющие символы (включая \t \n \r и NUL) — потенциальные обходы парсера → отвергаем.
  if (/[ -]/.test(decoded)) return null;

  // Браузер трактует обратный слэш как прямой: нормализуем для проверки protocol-relative
  // и схем, но возвращаем именно нормализованную форму (без backslash-трюков).
  const normalized = decoded.replace(/\\/g, '/');

  // Должен начинаться ровно с одного `/` и НЕ быть protocol-relative `//host`.
  if (normalized[0] !== '/') return null;
  if (normalized[1] === '/') return null;

  // Никакой схемы перед первым сегментом (отсекает `/javascript:...` крайние трюки и любые `:`
  // до первого слэша — у валидного локального пути двоеточие может быть только глубже).
  const firstSegment = normalized.slice(1).split('/')[0];
  if (firstSegment.indexOf(':') !== -1) return null;

  return normalized;
}

export { safeNext };
export default safeNext;
